import { Pipe, PipeTransform } from '@angular/core';
import { EventInfo } from '@zipari/shared-ds-util-digital-data';
import { LinkConfig } from '@zipari/shared-ds-util-navigation';

@Pipe({ name: 'getEventRoute' })
export class InfoPanelEventPipe implements PipeTransform {
  transform(item, field): Pick<LinkConfig, 'externalLink'> {
    return field?.route
      ? { externalLink: field.route }
      : { externalLink: item?.headerRoute || item?.headerLabel };
  }
}

@Pipe({ name: 'getPhoneEvent' })
export class InfoPanelPhoneEventPipe implements PipeTransform {
  transform(
    field,
  ): Pick<LinkConfig, 'externalLink'> & Pick<EventInfo, 'eventName'> {
    const internalClickEvent = 'Internal Nav Click';

    return field?.phone
      ? { externalLink: field.phone, eventName: internalClickEvent }
      : {
          externalLink: field?.route || field?.label,
          eventName: internalClickEvent,
        };
  }
}
